module.exports = __webpack_public_path__ + "media/images/light/logo/logo-on-white-6a4766b65fc1774b12cdd545f0588c0e.png";